import { convertKeysToCamelCase } from '../../../helpers/baseHelpers';
import style from '../../../assets/scss/components/designer/tools/CustomControls.module.scss';
import MaterialIcon from '../../common/MaterialIcon';
import { GeneralTooltip } from '../../common/GeneralTooltip';
import { useFlowControls } from '../../../hooks/flow/useFlowControls';
import { useTranslation } from 'react-i18next';

export const DownloadBlocksButton: React.FC = () => {
  const { button } = convertKeysToCamelCase(style);
  const { downloadBlocks } = useFlowControls();
  const { t } = useTranslation();

  return (
    <GeneralTooltip id={'tooltip-flow-download-blocks-button'} text={t('flow.controls.download')}>
      <div className={button} onClick={() => downloadBlocks()}>
        <MaterialIcon icon={'download'} />
      </div>
    </GeneralTooltip>
  );
};
